import api from '@/services/api'
import { createStore } from 'vuex'

const stored = (key, def) => {
  try {
    const v = localStorage.getItem(key)
    return v !== null ? JSON.parse(v) : def
  } catch {
    return def
  }
}

export default createStore({
  state: {
    baseUrl: 'https://api.task-board.uz/api',
    fileUrl: 'https://api.task-board.uz/storage/',
    token: localStorage.getItem('token'),
    language: localStorage.getItem('lang') || 'uz',
    loading: false,
    loaderCount: 0,
    user: null,
    taskBoard: false,
    totalPlayed:  stored('totalPlayed', 0),
    totalCorrect: stored('totalCorrect', 0),
    totalQ:       stored('totalQ', 0),
    totalPts:     stored('totalPts', 0),
    streak:       stored('streak', 0),
    history:      stored('history', []),
  },
  getters: {
    currentLanguage: state => state.language,
    isLoading: state => state.loaderCount > 0,
    accuracy: (state) => {
      return state.totalQ > 0
        ? Math.round((state.totalCorrect / state.totalQ) * 100)
        : 0
    },

    rankLabel: (state) => {
      if (state.totalPts >= 1000) return '🏆 Oltin daraja'
      if (state.totalPts >= 500)  return '🥈 Kumush daraja'
      return '🥉 Bronza daraja'
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
      localStorage.setItem('lang', lang);
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    setUser(state, user) {
      state.user = user;
    },
    INCREMENT_LOADER(state) {
      state.loaderCount++
    },
    DECREMENT_LOADER(state) {
      if (state.loaderCount > 0) state.loaderCount--
    },
    ADD_RESULT(state, { correct, total, points, catName, catEmoji }) {
      state.totalPlayed++
      state.totalCorrect += correct
      state.totalQ       += total
      state.totalPts     += points
      state.streak = correct === total ? state.streak + 1 : 0

      state.history.unshift({
        cat: catName,
        emoji: catEmoji,
        correct,
        total,
        pct: Math.round((correct / total) * 100),
        date: new Date().toLocaleDateString('uz-UZ'),
      })

      if (state.history.length > 10) state.history.pop()

      // localStorage sync
      localStorage.setItem('totalPlayed',  JSON.stringify(state.totalPlayed))
      localStorage.setItem('totalCorrect', JSON.stringify(state.totalCorrect))
      localStorage.setItem('totalQ',       JSON.stringify(state.totalQ))
      localStorage.setItem('totalPts',     JSON.stringify(state.totalPts))
      localStorage.setItem('streak',       JSON.stringify(state.streak))
      localStorage.setItem('history',      JSON.stringify(state.history))
    },
    SET_TASKBOARD(state, value) {
      state.taskBoard = value
      sessionStorage.setItem('taskboard', value)
    },
    logout(state) {
      state.token = null;
      state.user = [];
      localStorage.removeItem('token');
    }
  },
  actions: {
    async fetchUser({ commit }) {
      try {
        const response = await api.get('/user');
        commit('setUser', response.data);
      } catch (error) {
        if (error.response?.status === 401) {
          commit('logout');
        }
      }
    },
    async logout({ commit }) {
      commit('logout');
    },
    showLoader({ commit }) {
      commit('INCREMENT_LOADER')
    },
    hideLoader({ commit }) {
      commit('DECREMENT_LOADER')
    },
    addResult({ commit }, payload) {
      commit('ADD_RESULT', payload)
    },
  },
  modules: {

  }
})
